import { ITheme } from '../../app/common/shared/interfaces/ITheme';

export const lightTheme: ITheme = {
    bgColorPrimary: '#000',
    textColor: '#f2f2f2',
    petrolGradient: 'linear-gradient(180deg, #00FFB9 0%, #00E6DC 100%)',
    highlightColor: '#009999',
    actionColor: '#cf4b00',
    actionHoverColor: '#cf4b00',
    actionDisabledColor: '#ededed',
    actionDisabledBgColor: '#E5E5E9',
    bgColorSecondary: '#141414',
    bgHoverColor: '#E8E8E3',
    textColorSecondary: '#66667e',
    warningColor: '#d72339',
    inputBgColor: '#1A1A1A',
    inputBorderColor: '#4C4C68',
    inputActiveBgColor: '#000',
    inputActiveBorderColor: '#000',
    selectOptionHoverColor: '#476C7D',
    radioButtonBorderColor: '#4C4C68',
    radioButtonBGColor: 'transparent',
    slideThumbColor: '#ffffff',
    slideBarColor: '#7D8099',
    slideThumbActiveColor: '#196269',
    slideBarActiveColor: '#005159',
    slideBarDisabledColor: '#EBEBEE',
    slideThumbDisabledColor: '#CCCCD4',
    tabBorder: '#CCCCD4',
    tabLabelActiveColor: '#005159',
    tooltipBG: '#ffffff',
    tooltipSuccess: '#01893a',
    tooltipWarning: '#FFD732',
    tooltipError: '#D72339',
    heroBtnBgHover: '#62EEC7',
    inputErrorBG: '#331131',
    checkboxSelectedCheck: '#4C4C68',
    checkboxDisabledBorder: '#7D8099',
    expansionPanelBorder: '#000028',
    expansionPanelHoverBG: '#D1FFF2',
    expansionPanelHoverBorder: '#005159',
    primaryBtnBG: '#007993',
    primaryBtnBGHover: '#005159',
    primaryBtnText: '#ffffff',
    primaryBtnTextHover: '#ffffff',
    secondaryBtnBG: '#ffffff',
    secondaryBtnBGHover: '#D1FFF2',
    secondaryBtnText: '#007993',
    secondaryBtnTextHover: '#005159',
    tetriaryBtnBG: '#ffffff',
    tetriaryBtnBGHover: '#D1FFF2',
    tetriaryBtnText: '#007993',
    tetriaryBtnTextHover: '#005159',
    snackbarBg: '#ffffff',
    healthineersOrange: '#EC6602',
    tileBG: '#1A1A1A',
    tileBGHover: '#808080',
    skeletonBG: '#333333',
    tileBorder: '#808080',
    disabledColor: '#999999',
    btnPrimary: '#CF4B00',
    iconTitleColor: '#87D2D2',
    descriptionColor: '#E6E6E6',
    doughnutChartGreen: '#80CD9C',
    doughnutChartGray: '#CCCCCC',
    doughnutChartBlue: '#009999',
    doughnutChartOrange: '#EC6602',
    doughnutChartTeal: '#02D2ED',
    doughnutChartBrightGreen: '#A9ED02',
    doughnutChartBrown: '#986034',
    doughnutChartPurple: '#AB02ED',
    doughnutChartDarkYellow: '#FFC800',
    doughnutChartLightBlue: '#C8E6E6',
    doughnutChartWhite: '#FFFFFF',
    doughnutPictonBlue: '#3ABFED',
    barChartBlue: '#009999',
    textGrayColor: '#CCCCCC'
};

export const darkTheme: ITheme = {
    bgColorPrimary: '#000',
    bgColorSecondary: '#0A0A0A',
    bgHoverColor: '#37374D',
    textColor: '#f2f2f2',
    petrolGradient: 'linear-gradient(180deg, #00FFB9 0%, #00E6DC 100%)',
    highlightColor: '#009999',
    actionColor: '#ec6602',
    actionHoverColor: '#cf4b00',
    actionDisabledColor: '#ededed',
    actionDisabledBgColor: '#737389',
    textColorSecondary: '#9999A9',
    warningColor: '#FF7687',
    inputBgColor: '#1A1A1A',
    inputBorderColor: '#B3B3BE',
    inputActiveBgColor: 'rgb(51, 51, 51)',
    inputActiveBorderColor: 'rgb(64, 64, 64)',
    selectOptionHoverColor: 'rgb(230, 230, 230)',
    radioButtonBorderColor: '#B3B3BE',
    radioButtonBGColor: '#262648',
    slideThumbColor: '#000028',
    slideBarColor: '#9999A9',
    slideThumbActiveColor: '#FFFFFF',
    slideBarActiveColor: '#00E5AA',
    slideBarDisabledColor: '#333353',
    slideThumbDisabledColor: '#737389',
    tabBorder: '#737389',
    tabLabelActiveColor: '#00FFB9',
    tooltipBG: '#23233C',
    tooltipSuccess: '#01D65A',
    tooltipWarning: '#FFD732',
    tooltipError: '#FF2640',
    heroBtnBgHover: '#C5FFEF',
    inputErrorBG: '#331131',
    checkboxSelectedCheck: '#B3B3BE',
    checkboxDisabledBorder: '#737389',
    expansionPanelBorder: '#FFFFFF',
    expansionPanelHoverBG: '#001F39',
    expansionPanelHoverBorder: '#00FFB9',
    primaryBtnBG: '#00CCCC',
    primaryBtnBGHover: '#00FFB9',
    primaryBtnText: '#000028',
    primaryBtnTextHover: '#000028',
    secondaryBtnBG: '#000028',
    secondaryBtnBGHover: '#001F39',
    secondaryBtnText: '#00CCCC',
    secondaryBtnTextHover: '#00FFB9',
    tetriaryBtnBG: '#000028',
    tetriaryBtnBGHover: '#001F39',
    tetriaryBtnText: '#00CCCC',
    tetriaryBtnTextHover: '#00FFB9',
    snackbarBg: '#23233C',
    healthineersOrange: '#EC6602',
    tileBG: '#1A1A1A',
    tileBGHover: '#333333',
    skeletonBG: '#333333',
    tileBorder: '#808080',
    disabledColor: '#999999',
    btnPrimary: '#CF4B00',
    iconTitleColor: '#87D2D2',
    descriptionColor: '#E6E6E6',
    doughnutChartGreen: '#80CD9C',
    doughnutChartGray: '#CCCCCC',
    doughnutChartBlue: '#009999',
    doughnutChartOrange: '#EC6602',
    doughnutChartTeal: '#02D2ED',
    doughnutChartBrightGreen: '#A9ED02',
    doughnutChartBrown: '#986034',
    doughnutChartPurple: '#AB02ED',
    doughnutChartDarkYellow: '#FFC800',
    doughnutChartLightBlue: '#C8E6E6',
    doughnutChartWhite: '#FFFFFF',
    doughnutPictonBlue: '#3ABFED',
    barChartBlue: '#009999',
    textGrayColor: '#CCCCCC'
};
